<template>
  <div class="container-fluid p-3">
    <div class="card">
      <div class="card-header">
        <h5 class="text-center">HISTORIAL DE DECLARACIÓN DOMICILIARIA</h5>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-12 col-md-12 mb-3">
            <!-- <router-link :to="{ name: 'declaracion' }" class="btn btn-success">
              <i class="fa fa-plus"></i> <small> Nueva Declaración de Domicilio</small>
            </router-link> -->
            <a 
              class="btn btn-success"
              @click="Verifica"
            >
              <i class="fa fa-plus"></i> <small> Nueva Declaración de Domicilio</small>
            </a>
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-12 col-md-12">
            <div class="alert alert-warning" role="alert" style="background-color: rgba(248, 214, 43, 0.3);color:#000;">
              <i class="fa fa-exclamation-triangle"></i> <b>Atención</b><br> 
              Debe confirmar la declaración <b>(PENDIENTE)</b> de domicilio dentro las 48 hrs, después de la fecha de registro. Una vez vencido no se tomará en cuenta como una declaración formal.
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-12 col-md-12">
            <div
              class="table-responsive"
              style="overflow-y:scroll; height:380px;"
            >
              <table class="table table-bordered table-striped">
                <thead>
                  <tr class="text-center">
                    <th><small class="font-weight-bold">NRO</small></th>
                    <th><small class="font-weight-bold">CENTRO HOSPEDAJE</small></th>
                    <th><small class="font-weight-bold">TIPO</small></th>
                    <th><small class="font-weight-bold">DIRECCIÓN</small></th>
                    <th><small class="font-weight-bold">FECHA DECLARADA</small></th>
                    <th><small class="font-weight-bold">FECHA REGISTRO</small></th>
                     <th><small class="font-weight-bold">ESTADO<br>DECLARACIÓN</small></th>
                    <th><small class="font-weight-bold">ACCIONES</small></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in domicilios" :key="index">
                    <!--1-->
                    <td class="text-center" :class="{'alert-danger text-white': item.multa} ">
                      <small>{{ index + 1}}</small>
                    </td>
                    <!--2-->
                    <td>
                      <!-- <small v-if="item.tipo_domicilio == 'HOS'">{{ item.emp_razon_social}}</small>
                      <small v-if="item.tipo_domicilio == 'RES'">{{ item.domicilio }}</small> -->
                      <small v-if="item.tipo_domicilio == 'ND'">NO DECLARO DOMICILIO</small>
                      
                      <small v-if="item.tipo_domicilio == 'RE'">NO DECLARO DOMICILIO</small>
                      <small v-if="item.tipo_domicilio == 'NOT'">NOTIFICACIÓN</small>
                      <small v-else>{{ item.domicilio }}</small>
                    </td>
                    <!--3-->
                    <td class="text-center">
                      <small class="badge badge-success" v-if="item.tipo_domicilio == 'HOS'">CENTRO HOSPEDAJE</small>
                      <small class="badge badge-info" v-if="item.tipo_domicilio == 'RE'">REINGRESO</small>
                      <small class="badge badge-dark" v-if="item.tipo_domicilio == 'NOT'">NOTIFICACIÓN</small>
                      <small class="badge badge-warning" v-if="item.tipo_domicilio == 'RES'">DOMICILIO PARTICULAR</small>
                    </td>  
                    <!--4-->
                    <td>
                      <small v-if="item.empresa_persona == 1">
                        {{ item.direccion }} <br />
                        <span class="text-muted">{{ item.departamento }}</span>
                      </small>
                      <small v-if="item.tipo_domicilio == 'HOS' ">
                        {{ item.direccion }} <br />
                        <span class="text-muted">{{ item.departamento +" - "+ item.municipio }}</span>
                      </small>
                      <!-- <small v-if="item.municipio!='SIN MUNICIPIO'">
                        {{ item.direccion }} <br />
                        <span class="text-muted">{{ item.departamento +" - "+ item.municipio }}</span>
                      </small> -->
                      <small v-if="item.tipo_domicilio == 'RES'">
                        {{ item.direccion }} <br />
                        <span class="text-muted">{{ item.departamento }}</span>
                      </small>
                    </td>
                    <!--5-->
                    <td class="text-center">
                      <!-- <small v-if="item.tipo_domicilio == 'ND'">
                        {{ "Fecha Ingreso: " + item.fecha_reg }} 
                      </small> -->
                      <small v-if="item.tipo_domicilio == 'NOT'">
                        {{ "Fecha Notificación: " + item.fecha_reg }} 
                      </small>
                      <small v-if="item.tipo_domicilio == 'RE'">
                        {{ "Fecha Reingreso: " + item.fecha_reg }} 
                      </small>
                      <small v-if="item.tipo_domicilio != 'RE' && item.tipo_domicilio != 'NOT'&& item.tipo_domicilio != 'ND'">
                        {{ "De: " + item.fecha_inicio}} <br/>
                        {{ "A: " + item.fecha_fin}}
                      </small>
                    </td>
                    <!--6--> 
                    <td class="text-center">
                      <small>
                        {{ getDateTime(item.fecha_reg) }} 
                      </small>
                    </td>
                    <!--7--> 
                    <td class="text-center">
                      <small class="badge badge-danger" v-if="item.revisado==0 && item.verifica_estado == 1">
                        PENDIENTE
                      </small>
                      <small class="badge badge-danger" v-if="item.revisado==3">
                        VENCIDO
                      </small>
                      <small class="badge badge-danger" v-if="item.revisado==0 && item.verifica_estado == 0">
                        VENCIDO
                      </small>
                      <small class="badge badge-success" v-if="item.revisado==1 && item.nombre_domicilio!='Null'">
                        CONFIRMADO
                      </small>
                      <small class="badge badge-primary" v-if="item.pago==true">
                        CANCELADO
                      </small>

                      <small class="badge badge-info" v-if="item.revisado==2">
                        ANTERIOR
                      </small>
                    </td>
                    <!--8-->
                    <td class="text-center">
                      <a
                        class="btn btn-outline-info btn-sm"
                        title="Revisar Multa"
                        v-if="item.multa"
                        @click="onModalMulta(item)"
                      >
                        <i class="fa fa-eye"></i>
                      </a>

                      <!-- <a
                        class="btn btn-outline-success btn-sm"
                        title="Descargar Declaración"
                        v-if="item.revisado == '1'"
                       :href="'http://181.115.157.139:8678/restdgm/sitram/declaracionPDF/'+item.id_persona"
                        <i class="fa fa-print"></i>
                      </a>
                      > -->
                      <a
                        class="btn btn-outline-success btn-sm"
                        title="Descargar Declaración"
                        v-if="item.revisado=='1' && item.nombre_domicilio!='Null'"
                       :href="url+item.id_persona+'/'+item.id_domicilios">
                        <i class="fa fa-print"></i>
                      </a>

                      <a
                      
                        class="btn btn-warning btn-sm"
                        title="Confirmar declaración de domicilio"
                        v-if="item.revisado == '0' && !item.multa && item.tipo_domicilio != 'ND' && item.verifica_estado == 1"
                        @click="confirmarDomicilio(item.id_domicilios)"
                      >
                        <i class="fa fa-check"></i>
                      </a>
                      <a
                        class="btn btn-outline-danger btn-sm"
                        title="Quitar declaración de domicilio"
                        v-if="item.revisado == '0' && !item.multa && item.tipo_domicilio != 'ND' && item.verifica_estado == 1"
                        @click="quitarDomicilio(item.id_domicilios)"
                      >
                        <i class="fa fa-close"></i>
                      </a>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

      </div>
    </div>

    <b-modal
      class="modal fade"
      title="MULTA"
      hide-footer
      ref="modalMulta"
      :no-close-on-backdrop="true"
    >
      <div class="container">
        <div class="row">
          <div class="col-12 col-md-12">
            <p style="padding:20px;background:#f8d62b;">Si el ciudadano no declara su dirección en un máximo de dos días calendario, o se verifica que su declaración no es real, es sujeto a sanción según art. 37 de la reglamentación de la ley 370.</p>
            <p><strong>Descripción de la sanción:</strong></p>
            <p>{{multa.observacion_sancion}}</p>
            <p><strong>Multa: </strong> {{multa.valor_multa_ufv}} UFV</p>
            <p>Para subsanar su situación debe dirigirse a oficinas de la <b>Dirección General de Migración</b>, a objeto de regularizar su situación migratoria.</p>
          </div>
        </div>
      </div>
    </b-modal>
    <Loading v-show="cargando" />
  </div>
</template>

<script>
import Loading from "../../components/Loading";

import moment from "moment";

export default {

  components: {
    Loading,
  },
  data() {
    return {
      domicilios: [],
      persona: [],
      valor: "http://181.115.157.139:8678/restdgm/sitram/declaracionPDF/",
      cargando: false,
      multa: {},
    url: process.env.VUE_APP_URL + '/documento/2/',
    };
  },
  methods: {
    async onLoadDomicilios() {
      this.cargando = true;
      try {
        this.cargando = true;
        let res = await this.axios.post(`/domicilioData`);
        this.domicilios = res.data.contenido;
        this.cargando = false;
      } catch (error) {
        this.cargando = false;
        this.$swal({
          title: 'Información',
          text: 'Ocurrio un Error al realizar la consulta!',
          type: 'error',
          confirmButtonText: 'Aceptar'
        });
      }
    },
    formatFecha(event) {
      let str = event;
      let arrayFecha = str.split("-");
      return arrayFecha[2] + "/" + arrayFecha[1] + "/" + arrayFecha[0];
    },
    getDate: function(date) {
      if(date != '' || date != undefined){
      return moment(date).format("YYYY-MM-DD");
      }
      else{
        return '';
      }
    },
    getDateTime: function(date) {
      if(date != '' || date != undefined){
      return moment(date).format("DD/MM/YYYY HH:mm:ss");
      }
      else{
        return '';
      }
    },
    confirmarDomicilio(id_domicilios) {
      this.$swal({
        //title: 'Esta Seguro?',
        html: 'Debe confirmar la declaración de domicilio.',
        type: 'warning',
        confirmButtonText: 'Si, Confirmar Declaración!',
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33"
      })
      .then(async (result) => {
        if (result.value) {
          try {
            // Todos los anteriores
            await this.axios.put(`/domicilioAnterior`);
            // Actual vigente
            await this.axios.put(`/domicilioConfirmar/${id_domicilios}`);

            this.$swal({
              text: 'Declaración de domicilio realizado correctamente.',
              type: 'success',
              confirmButtonText: 'Aceptar'
            });
            this.onLoadDomicilios();
          } catch (error) {
            console.log(error);
          }
        }
      });
    },
    quitarDomicilio(id_domicilios) {
      this.$swal({
        title: 'Esta Seguro?',
        html: 'De quitar la Declaración de Domicilio.',
        type: 'warning',
        confirmButtonText: 'Si, Quitar Declaración',
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33"
      })
      .then(async (result) => {
        if (result.value) {
          try {
            await this.axios.put(`/quitarDomicilio/${id_domicilios}`);
            this.$swal({
              text: 'Se quito la Declaración de Domicilio correctamente.',
              type: 'success',
              confirmButtonText: 'Aceptar'
            });

            this.onLoadDomicilios();
          } catch (error) {
            console.log(error);
          }
        }
      });
    },
    // formar una selección única en la tabla
			cambiaColor(item){
				this.currentRow = item.multa;
				//console.log(this.currentRow)
			},
    showModal() {
      this.$refs["modalMulta"].show();
    },
    hideModal() {
      this.$refs["modalMulta"].hide();
    },
    onModalMulta(item){
      this.multa = item;
      this.$refs["modalMulta"].show();
    },
    async Verifica() {
      this.cargando = true;
      try {
        this.cargando = true;
        //let res = await this.axios.get(`/noFinalizadoDomicilio`);
        let res = await this.axios.get(`/VerificaRevisado`);
        console.log("resultado",res);
        let count = res.data.contenido;
        this.cargando = false;
        if(Number(count.inicio) >= 1 ){
          this.$swal({
            title: 'Información',
            html: '<b>Confirme</b> o <b>quite</b> última declaración de domicilio.',
            type: 'info',
            confirmButtonText: 'Aceptar'
          });
        }
        else{
          this.$router.push({name: 'declaracion'});
        }
      } catch (error) {
        this.cargando = false;
      }
    },

  },
  created() {
    this.onLoadDomicilios();
  },
};
</script>
